const r = {
  name: "VirtualCard",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 7C2 6.45228 2.45228 6 3 6H4V4H3C1.34772 4 0 5.34772 0 7V12H2V10H14V8H2V7Z" fill="currentColor"/>
<path d="M2 17C2 17.5477 2.45228 18 3 18H9V20H3C1.34772 20 0 18.6523 0 17V14H2V17Z" fill="currentColor"/>
<path d="M24 16H22V17C22 17.5477 21.5477 18 21 18H15V20H21C22.6523 20 24 18.6523 24 17V16Z" fill="currentColor"/>
<path d="M21 4H20V6H21C21.5477 6 22 6.45228 22 7V8H20V10H24V7C24 5.34772 22.6523 4 21 4Z" fill="currentColor"/>
<path d="M4 14H10V16H4V14Z" fill="currentColor"/>
<path d="M18 4H10V6H18V4Z" fill="currentColor"/>
<path d="M8 6H6V4H8V6Z" fill="currentColor"/>
<path d="M16 10H18V8H16V10Z" fill="currentColor"/>
<path d="M13 20H11V18H13V20Z" fill="currentColor"/>
<path d="M22 12V14H24V12H22Z" fill="currentColor"/>
</svg>
  `
};
export {
  r as VirtualCard
};
